<template>
	<div dir="ltr">
		<v-app-bar app dense color="primary" clipped-left>
			<v-toolbar-items>
				<v-app-bar-nav-icon dark @click="toggleDrawer"></v-app-bar-nav-icon>
			</v-toolbar-items>
			<v-toolbar-title class="headline">
				<router-link to="/" style="text-decoration: none" class="white--text">
					<span class="font-weight-medium">Tele</span>
					<span class="font-weight-light">Retina</span>
				</router-link>
			</v-toolbar-title>
		</v-app-bar>

		<v-navigation-drawer
			v-model="drawer"
			app
			:temporary="$vuetify.breakpoint.smAndDown"
			dark
			color="primary"
			clipped
			:mini-variant="mini"
		>
			<template v-slot:prepend>
				<v-list-item v-if="USER" two-line>
					<v-list-item-action>
						<v-icon>mdi-account</v-icon>
					</v-list-item-action>

					<v-list-item-content>
						<v-list-item-title>{{ DISPLAYNAME }}</v-list-item-title>
						<v-list-item-subtitle>{{ USER }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</template>

			<v-list nav>
				<template v-for="(item,i) in items">
					<app-drawer-item :key="i" :item="item" active-class="secondary--text"></app-drawer-item>
				</template>
			</v-list>

			<template v-slot:append>
				<v-list-item @click="toggleMini">
					<v-list-item-action>
						<v-icon>mdi-arrow-split-vertical</v-icon>
					</v-list-item-action>
					<v-list-item-title>Shrink</v-list-item-title>
				</v-list-item>
				<v-list-item v-if="USER" @click="logout">
					<v-list-item-action>
						<v-icon>mdi-exit-run</v-icon>
					</v-list-item-action>
					<v-list-item-title>Log out</v-list-item-title>
				</v-list-item>
			</template>
		</v-navigation-drawer>
	</div>
</template>

<script>
export default {
	components: {
		"app-drawer-item": require("./AppDrawerItem.vue").default
	},
	mixins: [
		require("@/mixins/cookie-mixin.vue").default,
		require("@/mixins/backend-mixin").default
	],
	data() {
		return {
			dialog: false,
			offsetTop: 0,
			drawer: null,
			mini: null
		};
	},
	computed: {
		items() {
			if (this.USER == "Camera Man") {
				return [
					{
						title: "Home",
						icon: "mdi-hospital-building",
						link: "/new-appointment"
					},
					{
						title: "Patients",
						icon: "mdi-account-group",
						link: "/eye-doc"
					},
					{
						title: "Add a New Patient",
						icon: "mdi-account-plus",
						link: "/patient"
					}
					// {
					// 	title: "Medical Information",
					// 	icon: "mdi-medical-bag",
					// 	link: "/patient-med-info"
					// },
					// {
					// 	title: "Upload Data by Excel",
					// 	icon: "mdi-google-spreadsheet",
					// 	link: "#"
					// },
					// {
					// 	title: "Grade",
					// 	icon: "mdi-format-list-checks",
					// 	link: "/grading/SOMETHING"
					// },
					// {
					// 	title: "Reports",
					// 	icon: "mdi-file-chart",
					// 	link: "/report/SOMETHING"
					// }
				];
			} else if (this.USER == "Eye Specialist") {
				return [
					{
						title: "Home",
						icon: "mdi-hospital-building",
						link: "/new-appointment"
					},
					{
						title: "Patients",
						icon: "mdi-account-group",
						link: "/eye-doc"
					},
					{
						title: "Add a New Patient",
						icon: "mdi-account-plus",
						link: "/patient"
					}
					// {
					// 	title: "Grade",
					// 	icon: "mdi-format-list-checks",
					// 	link: "/grading/SOMETHING"
					// },
					// {
					// 	title: "Random sample",
					// 	icon: "mdi-numeric-1-box-multiple-outline",
					// 	link: "/grading/SOMETHING"
					// }
				];
			} else if (this.USER == "Data Entry") {
				return [
					{
						title: "Home",
						icon: "mdi-hospital-building",
						link: "/new-appointment"
					},
					{
						title: "Patients",
						icon: "mdi-account-group",
						link: "/eye-doc"
					},
					{
						title: "Add a New Patient",
						icon: "mdi-account-plus",
						link: "/patient"
					}
					// {
					// 	title: "Grade",
					// 	icon: "mdi-format-list-checks",
					// 	link: "/grading/SOMETHING"
					// },
					// {
					// 	title: "Random sample",
					// 	icon: "mdi-numeric-1-box-multiple-outline",
					// 	link: "/grading/SOMETHING"
					// }
				];
			} else if (this.USER == "Admin" || this.USER == "Super Admin") {
				var items = [
					{
						title: "Dashboard",
						icon: "mdi-settings",
						link: "/dashboard/home/"
					}
				];
				if (this.$route.path.indexOf("/stat") != -1) {
					var statItems = [
						{
							title: "Statistics",
							icon: "mdi-chart-areaspline",
							link: "/dashboard/stat/"
						},
						{
							title: "Users Statistics",
							icon: "mdi-chart-areaspline",
							link: "/dashboard/stat/users/"
						},
						{
							title: "Eye Specialists Statistics",
							icon: "mdi-chart-areaspline",
							link: "/dashboard/stat/eye-specialists/"
						},

						{
							title: "Patients Statistics",
							icon: "mdi-chart-areaspline",
							link: "/dashboard/stat/patients/"
						},
						{
							title: "Appointments Statistics",
							icon: "mdi-chart-areaspline",
							link: "/dashboard/stat/appointments/"
						},
						{
							title: "Reports Statistics",
							icon: "mdi-chart-areaspline",
							link: "/dashboard/stat/reports/"
						}
					];

					items.push(...statItems);
				}
				return items;
			} else {
				return [
					{
						title: "Home",
						icon: "mdi-home",
						link: "/"
					}
				];
			}
		},
		USER() {
			return this.$store.state.user;
		},
		DISPLAYNAME() {
			if (this.$store.state.userInfo == null) {
				return "";
			}
			var user = this.$store.state.userInfo;
			var name = user.FirstName + " " + user.FamilyName;
			return name;
		}
	},
	created() {
		this.markActive();
		this.keepDrawerState();
	},
	methods: {
		logout() {
			// TODO
			this.$router.push("/");
			this.clearBackendToken();
			this.$store.dispatch("setUserInfo", null);
		},
		keepDrawerState() {
			var cond =
				this.getCookie("drawerEnabled") === "true" &&
				this.$vuetify.breakpoint.mdAndUp;

			if (cond) {
				this.drawer = true;
			} else {
				this.drawer = false;
			}
			this.keepMiniState();
		},
		keepMiniState() {
			if (this.getCookie("miniEnabled") === "true") {
				this.mini = true;
			} else {
				this.mini = false;
			}
		},
		markActive() {
			var link = document.location.hash.substring(1);

			if (this.items == undefined) {
				setTimeout(() => {
					this.markActive();
				}, 500);
				return;
			}

			this.items.forEach(item => {
				if (item.link == link) {
					item.expand = true;
				}
			});
		},
		toggleDrawer() {
			this.drawer = !this.drawer;
			this.setCookie("drawerEnabled", this.drawer);
		},
		toggleMini() {
			this.mini = !this.mini;
			this.setCookie("miniEnabled", this.mini);
		}
	}
};
</script>